'use strict';

/**
 * @const {number}
 * Handshake length.
 */
const HK_LENGTH = 32;

/**
 * @const {number}
 * Offline key maximum settable slot.
 *
 * 0 -- Online key
 * [1-253] -- Owner offline keys
 * 254 -- Guest offline key
 * 255 -- Keypad offline key
 * [256-511] -- Homekit offline keys
 */
const OFFLINE_KEY_MAX_SETTABLE_SLOT = 511;

exports.HK_LENGTH = HK_LENGTH;
exports.OFFLINE_KEY_MAX_SETTABLE_SLOT = OFFLINE_KEY_MAX_SETTABLE_SLOT;
